import * as actionTypes from 'constants/ActionTypes';

export function getLoadingAndDischarging() {
    return {
        type: actionTypes.GET_LOADING_AND_DISCHARGING.REQUEST,
    };
}

export function updateLoadingAndDischarging(item) {
    return {
        type: actionTypes.UPDATE_LOADING_AND_DISCHARGING.REQUEST,
        item,
    };
}

export function deleteLoadingAndDischarging(item) {
    return {
        type: actionTypes.DELETE_LOADING_AND_DISCHARGING.REQUEST,
        item,
    };
}

export function saveStatusLoadingAndDischarging(item) {
    return {
        type: actionTypes.SAVE_STATUS_LOADING_AND_DISCHARGING,
        item,
    };
}

export function clearStatusLoadingAndDischarging(item) {
    return {
        type: actionTypes.CLEAR_STATUS_LOADING_AND_DISCHARGING,
        item,
    };
}

export function searchLoadingAndDischarging(search) {
    return {
        type: actionTypes.SEARCH_LOADING_AND_DISCHARGING,
        search,
    };
}



// WEBPACK FOOTER //
// ./app/actions/cargoes/ldRates.js